import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Pagination, SignedUrlObject } from '@shared/models';
import { ApprovalFlowResponse } from '@shared/models/approval-flow.model';
import { BaseService } from '@shared/services/base.service';

import { StoreExpenseRequestListContent, StoreExpenseSearchCriteria } from '../model/store-expense.model';

@Injectable({
  providedIn: 'root'
})
export class StoreExpenseService extends BaseService {
  public headers: HttpHeaders;
  constructor(private readonly http: HttpClient) {
    super();

    this.envService = this.env.services.storeExpense;
    this.headers = new HttpHeaders(this.envService.headers);
  }

  getStoreExpenseRequestList(criteria: StoreExpenseSearchCriteria) {
    const url = this.getUrl();
    const params = this.getParams(criteria);

    return this.http.get<Pagination<StoreExpenseRequestListContent>>(url, {
      headers: this.loaderHeaders(null),
      observe: 'body',
      params
    });
  }

  getStoreExpenseRequestView(docNo: string) {
    const url = this.getFullUrl(this.envService.view, { docNo });

    return this.http.get<any>(url, {
      headers: this.loaderHeaders(),
      observe: 'body'
    });
  }

  getFileUrl(refId: string): Observable<SignedUrlObject> {
    const url = this.getFullUrl(this.envService.fileUrl);
    return this.http.post<SignedUrlObject>(url, { refId }, { headers: this.headers });
  }

  approveReject(payload: any, docNo: string) {
    const url = this.getFullUrl(this.envService.approveReject, { docNo });
    return this.http.post<any>(url, payload, {
      headers: this.loaderHeaders(),
      observe: 'body'
    });
  }

  history(docNo: string) {
    const url = this.getFullUrl(this.envService.history, { docNo });
    return this.http.get<any>(url, {
      headers: this.loaderHeaders(),
      observe: 'body'
    });
  }

  regenerateApprovalWorkflow(payload: { requestNo: string; version: number }) {
    const url = this.getFullUrl(this.envService.regenerateApprovalWorkflow);
    return this.http.post<ApprovalFlowResponse>(url, payload, {
      headers: this.loaderHeaders(),
      observe: 'body'
    });
  }
}
